/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_JOINT_BUSINESS_PLANS = gql`
  query GetJointBusinessPlans($input: JointBusinessPlansInput!) {
    jointBusinessPlans(input: $input) {
      count
      hasMore
      results {
        id
        name
      }
    }
  }
`
